<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>留学协同记录</span>
          </div>
          <el-form
            :inline="true"
            :model="searchData"
            class="logSearch">
            <el-row>
              <el-col :span="8">
                <label class="form-tit">客户编码</label>
                <el-input
                  v-model="searchData.crm_id"
                  class="jm-input-common"
                  size="small"/>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">原咨询</label>
                <el-select
                  v-model="searchData.old_sayer"
                  class="jm-input-common"
                  clearable
                  placeholder="请选择"
                  filterable>
                  <el-option-group
                    v-for="(group, k) in ds.advisory_teacher"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      :key="`${item.country}_${item.userid}`"
                      :label="item.truename"
                      :value="item.userid"/>
                  </el-option-group>
                </el-select>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">新咨询</label>
                <el-select
                  v-model="searchData.new_sayer"
                  class="jm-input-common"
                  clearable
                  placeholder="请选择"
                  filterable>
                  <el-option-group
                    v-for="(group, k) in ds.advisory_teacher"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      :key="`${item.country}_${item.userid}`"
                      :label="item.truename"
                      :value="item.userid"/>
                  </el-option-group>
                </el-select>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">原国家</label>
                <jm-dict-select
                  v-model="searchData.old_country"
                  empty-value="0"
                  empty-label="请选择"
                  type="online"
                  dict-type="country"/>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">新国家</label>
                <jm-dict-select
                  v-model="searchData.new_country"
                  empty-value="0"
                  empty-label="请选择"
                  type="online"
                  dict-type="country"/>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">转移时间</label>
                <el-date-picker
                  class="jm-input-common"
                  :editable="false"
                  type="daterange"
                  v-model="searchData.create_time"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  clearable
                  placeholder="请选择"/>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">客户分级</label>
                <jm-dict-select
                  class="jm-input-common"
                  clearable
                  type="dataset"
                  v-model="searchData.customerClassification"
                  dict-type="student"
                  name="customLvType"
                />
              </el-col>
              <el-col :span="8">
                <label class="form-tit">签约日期</label>
                <el-date-picker
                  class="jm-input-common"
                  :editable="false"
                  type="daterange"
                  v-model="searchData.signingdate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  clearable
                  placeholder="请选择"/>
              </el-col>
              <el-col :span="24">
                <label class="form-tit">渠道来源</label>
                <jm-channel
                  v-model="searchData.channel"
                  clearable
                  filterable/>
              </el-col>
            </el-row>
            <div class="searchBottom">
              <el-button
                class="jm-input-common3"
                type="primary"
                @click="onSearch">查询</el-button>
              <el-button
                class="jm-input-common3"
                type="default"
                @click="clearSeachData">清空</el-button>
            </div>
          </el-form>
          <jm-tableList
            url="/index/system/fibSyncList"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList">
            <el-table-column slot="firstColumn" type="expand">
              <template slot-scope="props">
                <p label-position="left" inline v-for="(str, key) in props.row.visit_list" :key="key">{{ str }}</p>
              </template>
            </el-table-column>
            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              :label="scope.label"
              width="150">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'editStudent', params: { id: scope.row.id } }">
                  {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              slot="custom_from"
              slot-scope="scope"
              :label="scope.label"
              width="450">
              <template slot-scope="scope">
                {{ scope.row.custom_from }}
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jmTableList from '@/components/data/tableList';
import student from '../student/student';
import {
  jmChannel,
  jmDictSelect
} from '@/components/tool';

export default {
  components: {
    jmTableList,
    jmChannel,
    jmDictSelect
  },
  mixins: [student],
  data() {
    return {
      refresh: false,
      searchData: {
        crm_id: '',
        old_sayer: '',
        new_sayer: '',
        old_country: '',
        new_country: '',
        create_time: [],
        signingdate: [],
        customerClassification: '',
        channel: {}
      },
    };
  },
  methods: {
    fetchData() {
      this.getDatasource();
    },
    onSearch() {
      this.refresh = true;
    },
    clearSeachData() {
      this.searchData = Object.assign({}, {
        crm_id: '',
        old_sayer: '',
        new_sayer: '',
        old_country: '',
        new_country: '',
        create_time: [],
        signingdate: [],
        customerClassification: '',
        channel: {}
      });
    }
  },
  beforeMount() {
    this.fetchData();
  },
};
</script>
<style>
  .logSearch {
    padding: .5em 0;
  }

  .logSearch .el-col {
    margin-bottom: 10px;
  }

  .logSearch .el-col .form-tit{
    width: 100px;
    display: inline-block;
  }
</style>
